import React from 'react';

export default function Indent() {
	return <span id='marge' style={{marginLeft: "3em"}}/>
}
